import { render, staticRenderFns } from "./TabletThicknessWidget.vue?vue&type=template&id=3804a79d&scoped=true&"
import script from "./TabletThicknessWidget.vue?vue&type=script&lang=ts&"
export * from "./TabletThicknessWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804a79d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
